import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_ENV === "PROD"
    ? "https://gems.bookingjini.com/api/extranetv4/"
    : "https://dev.gems.bookingjini.com/api",
})
